var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 3.02939L10.8 0.0293873C10.365 -0.0606127 9.9 0.0593874 9.555 0.344387C9.21 0.629387 9 1.04939 9 1.49939V2.99939H1.5C0.675 2.99939 0 3.67439 0 4.49939V25.4994C0 26.3244 0.675 26.9994 1.5 26.9994H9V28.4994C9 28.9494 9.195 29.3694 9.555 29.6544C9.825 29.8794 10.155 29.9994 10.5 29.9994C10.605 29.9994 10.695 29.9994 10.8 29.9694L25.8 26.9694C26.505 26.8344 27 26.2194 27 25.4994V4.49939C27 3.77939 26.49 3.16439 25.8 3.02939ZM3 23.9994V5.99939H9V23.9994H3ZM15 16.4994C14.175 16.4994 13.5 15.8244 13.5 14.9994C13.5 14.1744 14.175 13.4994 15 13.4994C15.825 13.4994 16.5 14.1744 16.5 14.9994C16.5 15.8244 15.825 16.4994 15 16.4994Z",
    fill: "#EA3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOut);
export default __webpack_public_path__ + "static/media/door-out.8f34504b.svg";
export { ForwardRef as ReactComponent };